import { Form, Input } from "antd";
import ContentLayout from "../components/layout/ContentLayout";
import MyBreadcrumb from "../components/layout/MyBreadcrumb";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import Button from "../components/Button";

export default function SettingsAccountPass() {
  return (
    <ContentLayout
      header={
        <>
          <h1>Change Password</h1>
          <MyBreadcrumb />
        </>
      }
    >
      <Form className="rewards-form pass-form" layout="vertical">
        <div className="rewards-form-section">
          <div className="rewards-inputs">
            <Form.Item name="currentPassword" label="Current Password" required>
              <Input.Password
                iconRender={(visible) =>
                  visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                }
              />
            </Form.Item>
            <Form.Item name="pass1" label="New Password" required>
              <Input.Password
                iconRender={(visible) =>
                  visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                }
              />
            </Form.Item>
            <Form.Item name="pass2" label="Confirm Password" required>
              <Input.Password
                iconRender={(visible) =>
                  visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                }
              />
            </Form.Item>
            <ul>
              <li>Use 8 or more characters</li>
              <li>Use 8 or more characters</li>
              <li>Use 8 or more characters</li>
              <li>Use 8 or more characters</li>
              <li>Use 8 or more characters</li>
            </ul>
            <Form.Item className="rewards-form-btn">
              <Button>Save</Button>
            </Form.Item>
          </div>
        </div>
      </Form>
    </ContentLayout>
  );
}
